export default __webpack_public_path__ + "static/media/etapa6.736840d3.png";